import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "X",
  "use": "X-usage",
  "viewBox": "0 0 17 17",
  "content": "<symbol viewBox=\"0 0 17 17\" id=\"X\">\n  <path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"M16.917 1.704L15.213 0 8.458 6.755 1.704 0 0 1.704l6.755 6.754L0 15.213l1.704 1.704 6.754-6.755 6.755 6.755 1.704-1.704-6.755-6.755z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol